var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "m15.023 5.79-3.937-3.938a.56.56 0 0 0-.399-.165h-6.75a1.125 1.125 0 0 0-1.124 1.126v12.375a1.125 1.125 0 0 0 1.124 1.124h10.126a1.125 1.125 0 0 0 1.124-1.125v-9a.56.56 0 0 0-.164-.397M11.25 3.608l2.017 2.017H11.25zm2.813 11.58H3.938V2.813h6.187v3.375a.563.563 0 0 0 .563.562h3.374zm-2.978-4.336a.563.563 0 0 1 0 .796l-1.687 1.688a.56.56 0 0 1-.796 0l-1.687-1.688a.563.563 0 0 1 .795-.796l.728.728V8.438a.563.563 0 1 1 1.124 0v3.142l.728-.728a.563.563 0 0 1 .796 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/UploadFile.5d7157669f0b358845dec15d26f90324.svg";
export { ForwardRef as ReactComponent };